import { useMutation } from '@tanstack/react-query';

import {
  type QuoteFile,
  useRequest,
  type QuoteFileCategory,
} from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

type BulkConvertQuoteItemsToQuoteFilesRequestBody = {
  quoteItemIds: number[];
  category?: QuoteFileCategory;
};

type BulkConvertQuoteItemsToQuoteFilesResponseBody = {
  failedQuoteItemConversions: number[];
  quoteFiles: QuoteFile[];
};

export const useBulkConvertQuoteItemsToQuoteFiles: MutationFunction<
  BulkConvertQuoteItemsToQuoteFilesResponseBody,
  BulkConvertQuoteItemsToQuoteFilesRequestBody,
  [{ quoteId: number }]
> = ({ quoteId }, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (requestData) => {
      return request(
        `/quotes/${quoteId}/bulk_convert_line_items_to_quote_files`,
        {
          init: {
            method: 'POST',
            body: requestData,
          },
        },
      );
    },
    ...queryOptions,
  });
};
